import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { EMAIL_VALIDATOR_PATTERN } from '@core/constants/FomPatterns';
import { AuthService } from '@core/modules/authentication/services/auth.service';
import { Observable, catchError, of } from 'rxjs';

@Component({
    selector: 'app-resend-verification-link-form',
    templateUrl: './resend-verification-link-form.component.html',
    styleUrls: ['./resend-verification-link-form.component.scss'],
    standalone: false
})
export class ResendVerificationLinkFormComponent implements OnInit {
  @Output() resendVerificationLink: EventEmitter<string> = new EventEmitter<string>();

  resendActivationAccountLink$: Observable<any> = of();

  form!: UntypedFormGroup;
  errorFeedbackList = this.loadFeedbackErrorLists();

  get emailControl(): UntypedFormControl {
    return this.form.get('email') as UntypedFormControl;
  }

  constructor(private fb: UntypedFormBuilder, private authService: AuthService) {}

  ngOnInit(): void {
    this.form = this.initForm();
  }

  onResendVerificationLink() {
    if (!this.form.valid) {
      return;
    }

    this.resendVerificationLink.emit(this.emailControl.value);
  }

  isSubmitted(control: AbstractControl): boolean {
    return !control.pristine;
  }

  private initForm(): UntypedFormGroup {
    return this.fb.group({
      email: ['', [Validators.required, Validators.pattern(EMAIL_VALIDATOR_PATTERN)]]
    });
  }

  private loadFeedbackErrorLists() {
    return {
      email: {
        required: 'form.errors.required',
        pattern: 'form.errors.emailLoginPattern'
      }
    };
  }
}
